import { api } from "@/lib/api";
import {
  TourAccommodationDto,
  TourAccommodationDtoListSchema,
  tourAccommodationFromDto,
} from "@/models";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function getTourAccommodationsQueryOptions(tourId: string) {
  return queryOptions({
    queryKey: ["tour-accommodations", tourId],
    queryFn: async () => {
      const result: Array<TourAccommodationDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache(
          "/api/tour-accommodations",
          TourAccommodationDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              TourId: Number.parseInt(tourId),
            },
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(tourAccommodationFromDto);
    },
  });
}

export function useGetTourAccommodations(tourId: string) {
  return useQuery(getTourAccommodationsQueryOptions(tourId));
}
